import { BellOutlined, FileImageOutlined, FileTextOutlined, GiftOutlined, PlayCircleOutlined, QrcodeOutlined, RocketOutlined, SendOutlined, ShareAltOutlined, TeamOutlined, TicketPercentOutlined, VideoCameraOutlined } from "./ui/icons";
import { marketingGroups, marketingPages, marketingPagePermission, type MarketingPageKey } from "./marketing-navigation";

const groupIcons: Record<typeof marketingGroups[number]["key"], React.ReactNode> = {
  marketingContent: <SendOutlined />,
  marketingPromotions: <GiftOutlined />,
  marketingCustomers: <TeamOutlined />
};

const icons: Record<MarketingPageKey, React.ReactNode> = {
  marketingLiveCodes: <QrcodeOutlined />,
  growth: <FileTextOutlined />,
  contentXiaohongshu: <FileImageOutlined />,
  contentWechatOfficial: <FileTextOutlined />,
  contentDouyin: <VideoCameraOutlined />,
  contentWechatChannels: <PlayCircleOutlined />,
  marketingCampaigns: <RocketOutlined />,
  marketingBenefits: <TicketPercentOutlined />,
  packageDistribution: <ShareAltOutlined />,
  benefitExpiry: <BellOutlined />
};

export const marketingMenuGroups = () => marketingGroups.map(group => group.key === "marketingContent"
  ? { key: "contentXiaohongshu", label: group.label, permission: marketingPagePermission("contentXiaohongshu"), icon: groupIcons[group.key] }
  : {
    ...group,
    icon: groupIcons[group.key],
    children: marketingPages.filter(page => page.group === group.key).map(page => ({ key: page.key, label: page.title, permission: marketingPagePermission(page.key), icon: icons[page.key] }))
  });
